import React, { FC, useState } from 'react';
import { batch } from 'react-redux';
import {
  useAppDispatch,
  useAppSelector,
  useFromChainWalletAddress,
} from '../hooks';
import {
  selectBridgeSlice,
  setSelectedToChain,
  setSelectedFromChain,
  TokenExtended,
  setSelectedToken,
  setTokenTransferAmount,
} from '../redux/slices/bridgeSlice';
import { setModal, selectModalSlice } from '../redux/slices/modalSlice';
import Modal from './common/Modal/Modal';
import {
  setFromChainWalletProvider,
  setToChainWalletProvider,
} from '../redux/slices/walletSlice';

const ModalChooseCoin: FC = () => {
  const dispatch = useAppDispatch();

  const { tokens } = useAppSelector(selectBridgeSlice);

  const [coinNameSearch, setCoinNameSearch] = useState(``);
  const [uiSelectedToken, setUiSelectedToken] = useState<TokenExtended>();

  const { modalShowing } = useAppSelector(selectModalSlice);
  const fromChainWalletAddress = useFromChainWalletAddress();
  const handleSearch = React.useCallback((evt) => {
    setCoinNameSearch(evt.target?.value);
  }, []);

  const handleChooseToken = React.useCallback(
    (evt) => {
      const targetTokenSymbol = evt.target.dataset.tokenSymbol;
      const foundToken = tokens.find(
        (token) => token.symbol === targetTokenSymbol,
      );
      if (!foundToken) return;
      if (foundToken?.isComingSoon) return;

      if (uiSelectedToken?.symbol === targetTokenSymbol) {
        setUiSelectedToken(undefined);
      } else {
        setUiSelectedToken(foundToken);
      }
    },
    [tokens, uiSelectedToken?.symbol],
  );

  const handleChooseCoinComplete = React.useCallback(() => {
    batch(() => {
      dispatch(setSelectedToken(uiSelectedToken || null));
      dispatch(setSelectedFromChain(null));
      dispatch(setTokenTransferAmount(null));
      dispatch(setFromChainWalletProvider(null));
      dispatch(setToChainWalletProvider(null));
      dispatch(setSelectedToChain(null));
      dispatch(setModal(`Hidden`));
    });
  }, [dispatch, uiSelectedToken]);

  const onClose = React.useCallback(() => {
    if (!fromChainWalletAddress) {
      dispatch(setSelectedToken(null));
      setUiSelectedToken(undefined);
    }
  }, [dispatch, fromChainWalletAddress]);

  return (
    <Modal
      size="sm"
      isShow={modalShowing === `ChooseCoin`}
      onClose={onClose}
      title="Select a token"
      explanation="Select a token to convert."
      headerComponentExtended={
        tokens.length > 12 ? (
          <div className="form-group has-icon-left">
            <input
              type="text"
              className="form-input input-lg"
              placeholder="코인명으로 검색하세요."
              value={coinNameSearch || ``}
              onChange={handleSearch}
            />
            <i className="form-icon icon icon-search" />
          </div>
        ) : null
      }
      footerComponent={
        <button
          className={
            uiSelectedToken
              ? `btn btn-block btn-primary btn-lg`
              : `btn btn-block btn-primary btn-lg disabled`
          }
          onClick={handleChooseCoinComplete}
        >
          Select
        </button>
      }
    >
      <div className="cards columns col-gapless" onClick={handleChooseToken}>
        {tokens.length > 0 ? (
          tokens.map((token) => {
            if (token.isComingSoon) {
              return (
                <div
                  key={token.symbol}
                  data-token-symbol={token.symbol}
                  className="card column col-3 disable"
                >
                  <i className="i-blockchain soon">soon</i>
                  <strong>preparing</strong>
                </div>
              );
            }

            return (
              <div
                key={token.symbol}
                data-token-symbol={token.symbol}
                className="card column col-3 disable"
              >
                <img
                  src={token.logoUrl}
                  className="i-blockchain"
                  alt={token.symbol}
                />
                <strong>{token.symbol}</strong>
                {uiSelectedToken?.symbol === token.symbol && (
                  <div
                    style={{
                      position: `absolute`,
                      left: 0,
                      top: 0,
                      width: `100%`,
                      height: `100%`,
                      backgroundColor: `rgba(13, 127, 233, 0.15)`,
                      borderRadius: 4,
                    }}
                  />
                )}
              </div>
            );
          })
        ) : (
          <div style={{ minHeight: 86 }} className="card column col-12">
            검색한 코인이 없습니다
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalChooseCoin;
